import React from 'react';
import PropTypes from 'prop-types';
import ActionButtons from './ActionButtons';
import ActionDropdown from './ActionDropdown';

const EVALUATE_ATTRIBUTES = Object.freeze({
  className: true,
  disabled: true,
  download: true,
  icon: true,
  iconFamily: true,
  iconTransform: true,
  keyField: true,
  showLabel: true,
  target: true,
  title: true,
  tooltip: true
});

const EVALUATE_ACTION = Object.freeze({
  link: true,
  externalLink: true
});

const MAX_ACTION_BUTTONS = 4;

const Actions = props => {
  const { actions = [], dropdownActions, row, ...additionalProps } = props;
  const actionsLength = actions.length;
  const filteredActions = actions
    .filter((action, index) => {
      if (typeof action.filter !== 'function') {
        return true;
      }
      return action.filter(row, index);
    })
    .map((action, index) => {
      const evaluatedAction = {};
      Object.entries(action).forEach(([key, value]) => {
        evaluatedAction[key] = EVALUATE_ATTRIBUTES[key] && typeof value === 'function' ?
          value(row, index) :
          value;
      });
      if (EVALUATE_ACTION[action.actionType] && typeof action.action === 'function') {
        evaluatedAction.action = action.action(row, index);
      }
      return evaluatedAction;
    });
  if ((actionsLength > MAX_ACTION_BUTTONS) || dropdownActions) {
    return (
      <ActionDropdown {...additionalProps} row={row} menuItems={filteredActions} />
    );
  } else {
    return (
      <ActionButtons {...additionalProps} row={row} buttons={filteredActions} />
    );
  }
};

Actions.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      action: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
      actionType: PropTypes.string.isRequired,
      className: PropTypes.string,
      disabled: PropTypes.bool,
      download: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
      iconFamily: PropTypes.string,
      iconTransform: PropTypes.string,
      icon: PropTypes.string,
      target: PropTypes.string,
      title: PropTypes.string,
      tooltip: PropTypes.string,
      type: PropTypes.oneOf(['edit', 'delete'])
    })
  ).isRequired,
  dropdownActions: PropTypes.bool,
  keyField: PropTypes.string,
  onToggle: PropTypes.func,
  row: PropTypes.object.isRequired
};

export default Actions;
